import { supabase } from "../supabaseClient";

export const INSTITUTION_BUSINESS_DEMO_MODE_KEY = "institutions_business_demo_mode";
export const INSTITUTION_BUSINESS_DEMO_CALENDLY_URL_KEY = "institutions_business_demo_calendly_url";
export const INSTITUTION_PUBLIC_PRICING_HIDDEN_KEY = "institutions_public_pricing_hidden";

export const parseBooleanSetting = (value) => {
  if (typeof value === "boolean") return value;
  const normalized = String(value || "").trim().toLowerCase();
  return ["true", "1", "yes", "on"].includes(normalized);
};

export const loadInstitutionBusinessDemoMode = async () => {
  const { data, error } = await supabase
    .from("app_settings")
    .select("value")
    .eq("key", INSTITUTION_BUSINESS_DEMO_MODE_KEY)
    .maybeSingle();
  if (error) throw error;
  return parseBooleanSetting(data?.value);
};

export const loadInstitutionPublicPricingHidden = async () => {
  const { data, error } = await supabase
    .from("app_settings")
    .select("value")
    .eq("key", INSTITUTION_PUBLIC_PRICING_HIDDEN_KEY)
    .maybeSingle();
  if (error) throw error;
  // Keep prices hidden if the setting is missing or cannot be loaded.
  return data ? parseBooleanSetting(data.value) : true;
};

export const normalizeInstitutionDemoCalendlyUrl = (value) => {
  const url = String(value || "").trim();
  if (!url) return "";
  if (!/^https:\/\/[^\s]+$/i.test(url)) return "";
  return url;
};

export const loadInstitutionBusinessDemoCalendlyUrl = async () => {
  const { data, error } = await supabase
    .from("app_external_links")
    .select("url")
    .eq("key", INSTITUTION_BUSINESS_DEMO_CALENDLY_URL_KEY)
    .maybeSingle();
  if (error) {
    if (error.code === "42P01" || /app_external_links|does not exist|schema cache/i.test(error.message || "")) return "";
    throw error;
  }
  return normalizeInstitutionDemoCalendlyUrl(data?.url);
};

export const loadInstitutionBusinessDemoConfig = async () => {
  const [demoModeResult, calendlyUrlResult, pricingHiddenResult] = await Promise.allSettled([
    loadInstitutionBusinessDemoMode(),
    loadInstitutionBusinessDemoCalendlyUrl(),
    loadInstitutionPublicPricingHidden(),
  ]);
  return {
    demoMode: demoModeResult.status === "fulfilled" ? demoModeResult.value : false,
    calendlyUrl: calendlyUrlResult.status === "fulfilled" ? calendlyUrlResult.value : "",
    publicPricingHidden: pricingHiddenResult.status === "fulfilled" ? pricingHiddenResult.value : true,
  };
};
